export const saveState = state => {
    try {
        const serializedState = JSON.stringify(state);
        localStorage.setItem('via_key', serializedState);
    } catch (e) {
        console.log('Could not save state')
    }
};

export const loadState = () => {
    try {
        const serializedStorage = localStorage.getItem('via_key');
        if (serializedStorage === null) {
            return undefined
        }

        return JSON.parse(serializedStorage)

    } catch (e) {
        return undefined
    }
};

export const removeState = () => {
    localStorage.removeItem('via_key')
}